namespace Matrix.Rebalancer {
    export namespace SummaryViewColumnService {
        export const baseUrl = 'Rebalancer/SummaryViewColumn';

        export declare function Create(request: Serenity.SaveRequest<SummaryViewColumnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SummaryViewColumnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SummaryViewColumnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<SummaryViewColumnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Rebalancer/SummaryViewColumn/Create",
            Update = "Rebalancer/SummaryViewColumn/Update",
            Delete = "Rebalancer/SummaryViewColumn/Delete",
            Retrieve = "Rebalancer/SummaryViewColumn/Retrieve",
            List = "Rebalancer/SummaryViewColumn/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SummaryViewColumnService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
